import React, { createContext, useContext, useState, useCallback } from 'react';
import { DiscoveryModal } from './DiscoveryModal';
import { AuditModal } from './AuditModal';
import { BookCallModal } from './BookCallModal';
import { ChatWidget } from './ChatWidget';

const DiscoveryContext = createContext(null);

export const useDiscovery = () => useContext(DiscoveryContext);

export const DiscoveryProvider = ({ children, defaultMarket = 'uk' }) => {
  const [open, setOpen] = useState(false);
  const [preselectedPackage, setPreselectedPackage] = useState(null);
  const [auditOpen, setAuditOpen] = useState(false);
  const [auditMagnet, setAuditMagnet] = useState(null);
  const [auditIndustry, setAuditIndustry] = useState(null);
  const [bookCallOpen, setBookCallOpen] = useState(false);
  const [bookCallContext, setBookCallContext] = useState(null);

  const openDiscovery = useCallback((pkg = null) => {
    setPreselectedPackage(pkg);
    setOpen(true);
  }, []);

  const openAudit = useCallback((magnet = null, industry = null) => {
    setAuditMagnet(magnet);
    setAuditIndustry(industry);
    setAuditOpen(true);
  }, []);

  const openBookCall = useCallback((context = null) => {
    setBookCallContext(context);
    setBookCallOpen(true);
  }, []);

  return (
    <DiscoveryContext.Provider value={{ openDiscovery, openAudit, openBookCall, market: defaultMarket }}>
      {children}
      <DiscoveryModal open={open} onOpenChange={setOpen} preselectedPackage={preselectedPackage} market={defaultMarket} />
      <AuditModal open={auditOpen} onOpenChange={setAuditOpen} magnet={auditMagnet} industry={auditIndustry} market={defaultMarket} />
      <BookCallModal open={bookCallOpen} onOpenChange={setBookCallOpen} context={bookCallContext} market={defaultMarket} />
      <ChatWidget market={defaultMarket} />
    </DiscoveryContext.Provider>
  );
};
